import React, { useState, useEffect } from 'react';
import { 
  Box, Grid, Card, CardContent, Typography, 
  Chip, CircularProgress, Alert,
  Dialog, DialogTitle, DialogContent,
  List, ListItem, ListItemText, Button
} from '@mui/material';
import {
  People, Assignment, Business, CalendarToday,
  AttachMoney, Warning, Schedule, Receipt
} from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

function Dashboard() {
console.log('Dashboard component is being called');  
  console.log('Dashboard component rendering');
  
  const { user } = useAuth();
  console.log('Dashboard user:', user);
  console.log('User roles:', user?.roles);
  
  const navigate = useNavigate(); // Add this if missing
  
  // ... rest of component
const isAdmin = user?.roles?.includes('admin');
const isSuperMadmin = user?.roles?.includes('super_madmin'); // Add this
const isMadmin = user?.roles?.includes('madmin');
const isEngineer = user?.roles?.includes('engineer');
  const isClient = user?.roles?.includes('client');
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
const [error, setError] = useState(null); // Add this line
 console.log('Role checks:', { isAdmin, isSuperMadmin, isMadmin, isEngineer, isClient });

// Add this state at the top with other states
const [showPendingDetails, setShowPendingDetails] = useState(false);
const [pendingDetails, setPendingDetails] = useState({
  pendingUsers: [],
  pendingInvoices: []
});

// Add this function to fetch pending details
const fetchPendingDetails = async () => {
  try {
    const response = await api.get('/dashboard/pending-details');
    setPendingDetails(response.data);
    setShowPendingDetails(true);
  } catch (error) {
    console.error('Error fetching pending details:', error);
  }
};

// Update the Pending Actions card to be clickable
{stats && stats.pendingActions > 0 && (
  <Grid item xs={12} sm={6} md={2.4}>
    <Card 
      sx={{ 
        bgcolor: 'warning.light',
        cursor: 'pointer',
        '&:hover': { boxShadow: 3 }
      }}
      onClick={fetchPendingDetails}
    >
      <CardContent>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box>
            <Typography color="text.secondary" gutterBottom>
              Pending Actions
            </Typography>
            <Typography variant="h4">
              {stats.pendingActions}
            </Typography>
          </Box>
          <Warning color="warning" />
        </Box>
        <Typography variant="caption" color="text.secondary">
          Click for details
        </Typography>
      </CardContent>
    </Card>
  </Grid>
)}

// Add a dialog to show pending details
<Dialog open={showPendingDetails} onClose={() => setShowPendingDetails(false)} maxWidth="md" fullWidth>
  <DialogTitle>Pending Actions</DialogTitle>
  <DialogContent>
    {pendingDetails.pendingUsers.length > 0 && (
      <Box mb={2}>
        <Typography variant="h6" gutterBottom>Pending User Approvals</Typography>
        <List>
          {pendingDetails.pendingUsers.map(user => (
            <ListItem key={user.id}>
              <ListItemText 
                primary={user.username}
                secondary={`Email: ${user.email} - Registered: ${new Date(user.created_at).toLocaleDateString()}`}
              />
              <Button size="small" variant="contained" onClick={() => window.location.href = '/users'}>
                Review
              </Button>
            </ListItem>
          ))}
        </List>
      </Box>
    )}
    
    {pendingDetails.pendingInvoices.length > 0 && (
      <Box>
        <Typography variant="h6" gutterBottom>Pending Invoices</Typography>
        <List>
          {pendingDetails.pendingInvoices.map(invoice => (
            <ListItem key={invoice.id}>
              <ListItemText 
                primary={`Invoice #${invoice.invoice_number}`}
                secondary={`Client: ${invoice.client_name} - Amount: ₦${invoice.total_amount.toLocaleString()}`}
              />
              <Button size="small" variant="contained" onClick={() => window.location.href = '/invoices'}>
                View
              </Button>
            </ListItem>
          ))}
        </List>
      </Box>
    )}
  </DialogContent>
</Dialog>



  useEffect(() => {
    fetchDashboardStats();
  }, []);

const fetchDashboardStats = async () => {
  try {
    setLoading(true);
    const response = await api.get('/dashboard/stats');
    console.log('Dashboard response:', response.data);
    console.log('User roles:', user?.roles);
    setStats(response.data);
  } catch (error) {
    console.error('Error fetching dashboard stats:', error);
    setError('Failed to load dashboard statistics');
  } finally {
    setLoading(false);
  }
};

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-NG', {
      style: 'currency',
      currency: 'NGN',
      minimumFractionDigits: 0
    }).format(amount || 0);
  };

  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffInHours = Math.floor((now - date) / (1000 * 60 * 60));
    
    if (diffInHours < 1) {
      const diffInMinutes = Math.floor((now - date) / (1000 * 60));
      return `${diffInMinutes} minutes ago`;
    } else if (diffInHours < 24) {
      return `${diffInHours} hours ago`;
    } else {
      const diffInDays = Math.floor(diffInHours / 24);
      return `${diffInDays} days ago`;
    }
  };

  const renderAdminDashboard = () => (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6} md={2.4}>
        <Card>
          <CardContent>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Box>
                <Typography color="text.secondary" gutterBottom>
                  Total Users
                </Typography>
                <Typography variant="h4">
                  {stats.totalUsers}
                </Typography>
              </Box>
              <People color="primary" />
            </Box>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} sm={6} md={2.4}>
        <Card>
          <CardContent>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Box>
                <Typography color="text.secondary" gutterBottom>
                  Active Projects
                </Typography>
                <Typography variant="h4">
                  {stats.activeProjects}
                </Typography>
              </Box>
              <Assignment color="success" />
            </Box>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} sm={6} md={2.4}>
        <Card>
          <CardContent>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Box>
                <Typography color="text.secondary" gutterBottom>
                  Total Clients
                </Typography>
                <Typography variant="h4">
                  {stats.totalClients}
                </Typography>
              </Box>
              <Business color="info" />
            </Box>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} sm={6} md={2.4}>
        <Card>
          <CardContent>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Box>
                <Typography color="text.secondary" gutterBottom>
                  Bookings
                </Typography>
                <Typography variant="h4">
                  {stats.totalBookings}
                </Typography>
              </Box>
              <CalendarToday color="secondary" />
            </Box>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} sm={6} md={2.4}>
        <Card>
          <CardContent>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Box>
                <Typography color="text.secondary" gutterBottom>
                  Revenue (Monthly)
                </Typography>
                <Typography variant="h5">
                  {formatCurrency(stats.revenue)}
                </Typography>
              </Box>
              <AttachMoney color="success" />
            </Box>
          </CardContent>
        </Card>
      </Grid>

      {stats.pendingActions > 0 && (
        <Grid item xs={12} sm={6} md={2.4}>
          <Card sx={{ bgcolor: 'warning.light' }}>
            <CardContent>
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Box>
                  <Typography color="text.secondary" gutterBottom>
                    Pending Actions
                  </Typography>
                  <Typography variant="h4">
                    {stats.pendingActions}
                  </Typography>
                </Box>
                <Warning color="warning" />
              </Box>
            </CardContent>
          </Card>
        </Grid>
      )}
    </Grid>
  );

  const renderMadminDashboard = () => (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6} md={3}>
        <Card>
          <CardContent>
            <Typography color="text.secondary" gutterBottom>
              Department Staff
            </Typography>
            <Typography variant="h4">
              {stats.departmentUsers}
            </Typography>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <Card>
          <CardContent>
            <Typography color="text.secondary" gutterBottom>
              Department Projects
            </Typography>
            <Typography variant="h4">
              {stats.departmentProjects}
            </Typography>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <Card>
          <CardContent>
            <Typography color="text.secondary" gutterBottom>
              Department Clients
            </Typography>
            <Typography variant="h4">
              {stats.departmentClients}
            </Typography>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <Card>
          <CardContent>
            <Typography color="text.secondary" gutterBottom>
              Department Revenue
            </Typography>
            <Typography variant="h5">
              {formatCurrency(stats.departmentRevenue)}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );

  const renderEngineerDashboard = () => (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6} md={4}>
        <Card>
          <CardContent>
            <Typography color="text.secondary" gutterBottom>
              Today's Sessions
            </Typography>
            <Typography variant="h4">
              {stats.todaySchedule}
            </Typography>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <Card>
          <CardContent>
            <Typography color="text.secondary" gutterBottom>
              Upcoming Bookings
            </Typography>
            <Typography variant="h4">
              {stats.myBookings}
            </Typography>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <Card>
          <CardContent>
            <Typography color="text.secondary" gutterBottom>
              Active Projects
            </Typography>
            <Typography variant="h4">
              {stats.activeProjects}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );

const renderStaffDashboard = () => (
  <Grid container spacing={3}>
    <Grid item xs={12}>
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Clock In/Out
          </Typography>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Welcome! Use the Staff Attendance menu to clock in or out.
          </Typography>
          <Box sx={{ mt: 2 }}>
            <Button 
              variant="contained" 
              onClick={() => window.location.href = '/attendance'}
            >
              Go to Attendance
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Grid>
    
    {/* You can add more staff-specific widgets here */}
    <Grid item xs={12} sm={6}>
      <Card>
        <CardContent>
          <Typography color="text.secondary" gutterBottom>
            Today's Date
          </Typography>
          <Typography variant="h5">
            {new Date().toLocaleDateString('en-US', { 
              weekday: 'long', 
              year: 'numeric', 
              month: 'long', 
              day: 'numeric' 
            })}
          </Typography>
        </CardContent>
      </Card>
    </Grid>
    
    <Grid item xs={12} sm={6}>
      <Card>
        <CardContent>
          <Typography color="text.secondary" gutterBottom>
            Current Time
          </Typography>
          <Typography variant="h5">
            {new Date().toLocaleTimeString()}
          </Typography>
        </CardContent>
      </Card>
    </Grid>
  </Grid>
);


  const renderClientDashboard = () => (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6} md={3}>
        <Card>
          <CardContent>
            <Typography color="text.secondary" gutterBottom>
              My Projects
            </Typography>
            <Typography variant="h4">
              {stats.myProjects}
            </Typography>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <Card>
          <CardContent>
            <Typography color="text.secondary" gutterBottom>
              My Bookings
            </Typography>
            <Typography variant="h4">
              {stats.myBookings}
            </Typography>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <Card>
          <CardContent>
            <Typography color="text.secondary" gutterBottom>
              Pending Invoices
            </Typography>
            <Typography variant="h4">
              {stats.invoices?.pending || 0}
            </Typography>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <Card>
          <CardContent>
            <Typography color="text.secondary" gutterBottom>
              Amount Due
            </Typography>
            <Typography variant="h5">
              {formatCurrency(stats.invoices?.amountDue)}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );

if (loading) {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
      <CircularProgress />
    </Box>
  );
}

if (!stats) {
  return (
    <Box p={3}>
      <Alert severity="error">
        Failed to load dashboard data. Please refresh the page.
      </Alert>
    </Box>
  );
} 

  const userRole = stats.userRole;

return (
  <Box>
    <Typography variant="h4" gutterBottom>
      Welcome back, {user?.full_name || user?.username}!
    </Typography>
    <Typography variant="body1" color="text.secondary" gutterBottom>
      {isAdmin && "Here's what's happening at Omega Studio today."}
      {(isSuperMadmin || isMadmin) && "Here's your department overview."}
      {isEngineer && "Here's your schedule and assignments."}
      {isClient && "Here's your account overview."}
    </Typography>
    
    <Box sx={{ mt: 3 }}>
      {(() => {
        if (isAdmin) {
          return renderAdminDashboard();
        } else if (isSuperMadmin) {
          return renderMadminDashboard();
        } else if (isMadmin) {
          return renderMadminDashboard();
        } else if (isEngineer) {
          return renderEngineerDashboard();
        } else if (isClient) {
          return renderClientDashboard();
        } else {
          return renderStaffDashboard();
        }
      })()}
    </Box>

    {/* Recent Activities */}
    {stats && stats.recentActivities && stats.recentActivities.length > 0 && (
      <Card sx={{ mt: 3 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Recent Activities
          </Typography>
          {stats.recentActivities.map((activity, index) => (
            <Box key={index} sx={{ mb: 2 }}>
              <Box display="flex" alignItems="center" justifyContent="space-between">
                <Box display="flex" alignItems="center" gap={1}>
                  <Chip 
                    label={activity.type} 
                    size="small" 
                    color={
                      activity.type === 'booking' ? 'primary' :
                      activity.type === 'payment' ? 'success' :
                      'default'
                    }
                  />
                  <Typography variant="body1">
                    {activity.title}
                  </Typography>
                </Box>
                <Typography variant="caption" color="text.secondary">
                  {formatTime(activity.time)}
                </Typography>
              </Box>
              <Typography variant="body2" color="text.secondary" sx={{ ml: 7 }}>
                {activity.description}
              </Typography>
            </Box>
          ))}
        </CardContent>
      </Card>
    )}
  </Box>
);

}
export default Dashboard;
